import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { RoutePermissions } from '@modules/iam/permissons/route.permissions';
import { userGuard } from '@guards/user.guard';
import { roleGuard } from '@guards/role.guard';
import { userRoutes } from '@routing/user.routes';
import { DashboardLayoutComponent } from '@modules/dashboard/layout/dashboard-layout.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: DashboardLayoutComponent,
        canActivate: [authGuard, userGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('@modules/dashboard/dashboard.routing').then((m) => m.DASHBOARD_ROUTES)
            },
            {
                path: 'employees',
                canActivate: [roleGuard],
                data: { allowedRoles: [...RoutePermissions.employees.access] },
                loadChildren: () => import('@modules/employee/employee.routing').then((m) => m.EMPLOYEE_ROUTES)
            },
            {
                path: 'applications',
                canActivate: [roleGuard],
                data: { allowedRoles: [...RoutePermissions.subsidy.access] },
                loadChildren: () => import('@modules/subsidy/subsidy.routing').then((m) => m.SUBSIDY_ROUTES)
            },
            {
                path: 'company',
                canActivate: [roleGuard],
                data: { allowedRoles: [...RoutePermissions.customer.access] },
                loadChildren: () => import('@modules/customer/customer.routing').then((m) => m.CUSTOMER_ROUTES)
            },
            {
                path: userRoutes['profile'],
                loadChildren: () => import('@modules/user/user.routing').then((m) => m.USER_ROUTES)
            },
            {
                path: 'benefits',
                canActivate: [roleGuard],

                data: { allowedRoles: [...RoutePermissions.benefits.access] },
                loadChildren: () => import('@modules/benefit/benefit.routing').then((m) => m.BENEFIT_ROUTES)
            },
            {
                path: 'exports',
                canActivate: [roleGuard],
                data: { allowedRoles: [...RoutePermissions.reports.access] },
                loadChildren: () => import('@modules/exports/exports.routing').then((m) => m.EXPORTS_ROUTES)
            },
            {
                path: 'iam',
                canActivate: [roleGuard],
                data: { allowedRoles: [...RoutePermissions.iam.access] },
                loadChildren: () => import('@modules/iam/iam.routing').then((m) => m.IAM_ROUTES)
            }
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('@modules/auth/auth.routing').then((m) => m.AUTH_ROUTES)
    }
];
